<template>
    <v-content style="overflow: hidden; ">
        <Header :fixed="true"></Header>

        <div style="margin-top: 64px;">
            <h1 class="text-center pt-3 mb-3">{{ $t('page.invoice.title') }}</h1>

            <iframe :src="invoicePath" frameborder="0" class="d-block invoice-iframe"></iframe>

            <div class="text-center pt-3 mb-3">
                <button @click="$router.push('/')">{{ $t('page.invoice.finish') }}</button>
            </div>
        </div>

        <Footer></Footer>
    </v-content>
</template>

<script>
    import Header from "../components/Header";
    import Footer from "../components/Footer";
    import Service from '../services';
    import { mapState, mapActions } from 'vuex'
    import { domain } from "../services/Constants";

    export default {
        name: "ShowInvoice",
        components: {
            Header,
            Footer
        },
        props: ['id'],
        computed: {
            ...mapState({
                language: state => state.locale.language,
            }),
            invoicePath: function () {
                return `${domain}uploads/pdf/invoices/invoice-${this.id}.pdf`
            }
        }
    }
</script>

<style lang="scss" scoped>
    html {
        overflow: hidden !important;
    }
    .invoice-iframe {
        width: 820px;
        margin: 0 auto;
        height: calc(100vh - 64px - 72px - 62px - 80px);
    }
    button {
        width: 282px;
        height: 50px;
        left: 499px;
        top: 1356px;

        background: linear-gradient(180deg, #F2F2F2 0%, #FFFFFF 53.13%, #F2F2F2 100%);
        border: 2px solid #C4C4C4;
        box-sizing: border-box;
        border-radius: 5px;
    }
</style>